import { axiosClient } from "@/lib/axios";
import { HttpError } from "@/types/error";
import { PublicRoomSystem } from "@classview/shared-types";
import { UseQueryOptions, useQuery } from "@tanstack/react-query";

export const getAvailableRoomSystemsForCall = async ({
  sessionId,
}: {
  sessionId: string;
}): Promise<PublicRoomSystem[]> => {
  const response = await axiosClient.get(`/room-systems/session/${sessionId}`);

  return response.data;
};

export function getAvailableRoomSystemsForCallQueryKey({
  sessionId,
}: {
  sessionId: string;
}) {
  return ["room-systems", "in-call", sessionId];
}

export function useGetAvailableRoomSystemsForCall(
  sessionId: string,
  queryOptions?: Partial<UseQueryOptions<PublicRoomSystem[], HttpError>>,
) {
  return useQuery({
    queryKey: getAvailableRoomSystemsForCallQueryKey({
      sessionId,
    }),
    queryFn: () =>
      getAvailableRoomSystemsForCall({
        sessionId,
      }),
    ...queryOptions,
  });
}
